import { Component } from '@angular/core';

@Component({
    selector: 'app-leagueOverview-widget',
    standalone: true,
    templateUrl: './leagueOverview.component.html',
    styleUrls: ['./leagueOverview.component.scss'],

})

export class LeagueOverview {}